import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRulesBreaking(companyId, query) {
	return dataTransferWrap(
		ModulesMap.RULES_BREAKING,dtConfig[ModulesMap.RULES_BREAKING].getRulesBreaking,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getRuleBreaking(companyId, ruleBreakingId) {
	return dataTransferWrap(
		ModulesMap.RULES_BREAKING,dtConfig[ModulesMap.RULES_BREAKING].getRuleBreaking,
		{
			urlParams: {
				companyId: companyId,
				ruleBreakingId,
			},
		},
	)
}

export default {
	getRulesBreaking,
	getRuleBreaking,
}
